import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { getPortalSdkUrl } from "@jari-tools/shared";
import { loadPortalSdk } from "./portal-sdk";
import { App } from "./App";
import "./tool.css";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

const params = new URLSearchParams(location.search);
// Mobiele bediening en cliëntweergave (beeldbellen) draaien zonder portal-login.
const isRemoteMode = params.has("remote") || params.has("sessie");

function render() {
  createRoot(root).render(
    isRemoteMode ? (
      <App />
    ) : (
      <StrictMode>
        <App />
      </StrictMode>
    )
  );
}

if (isRemoteMode) {
  render();
} else {
  loadPortalSdk(getPortalSdkUrl())
    .catch(() => {
      // Portal unreachable, App shows auth error; DevAccessPill works in dev.
    })
    .finally(render);
}
